import { z } from 'zod'

/**
 * What a Righty turn started in the page editor knows about it. It never carries HTML: the server loads the
 * selected element and its CSS block from `revisionId`, so the model works from the revision the user saw.
 * `layer` is the campaign layer being edited, absent on Everyone: Righty then writes only that audience (or page
 * test variant) version on this page, and never the page itself. `colorScheme` dark means the canvas shows the dark
 * palette, so color requests change it.
 */
export const pageEditorContextSchema = z.object({
  pageId: z.string().regex(/^pg_[A-Za-z0-9]{1,64}$/),
  revisionId: z.number().int().positive(),
  device: z.enum(['desktop', 'tablet', 'mobile']),
  mode: z.enum(['edit', 'preview']),
  colorScheme: z.enum(['light', 'dark']).optional(),
  selection: z
    .object({
      key: z.string().regex(/^[a-z][a-z0-9-]{0,63}$/),
      label: z.string().max(200),
      text: z.string().max(2000),
      slot: z.string().max(128).nullable()
    })
    .optional(),
  layer: z
    .object({
      campaignId: z.string().regex(/^cpn_[A-Za-z0-9_-]{1,64}$/),
      node: z.union([z.literal('original'), z.string().regex(/^var_[A-Za-z0-9_-]{1,64}$/)]),
      versionId: z.enum(['A', 'B', 'C', 'D'])
    })
    .optional()
})

export type PageEditorContext = z.infer<typeof pageEditorContextSchema>
export type PageEditorLayer = NonNullable<PageEditorContext['layer']>
